import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FollowUpQuestionComponent} from "../follow-up-question.component";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from "@angular/material/table";
import {ViewFollowUpEducationComponent} from "../../view-follow-up-education/view-follow-up-education.component";
import {CentreService} from "../../../../../services/centre.service";
import {CentreOption} from "../../../../../interfaces/Centres";
import {Observable, Subject} from "rxjs";
import {finalize, map, takeUntil} from "rxjs/operators";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {EducationService} from "../../../education.service";
import {LogService} from "../../../../../services/log.service";
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
    selector: 'app-follow-up-table',
    templateUrl: './follow-up-table.component.html',
    styleUrls: ['./follow-up-table.component.scss']
})
export class FollowUpTableComponent implements OnInit, OnDestroy {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    private _destroyed$ = new Subject<void>();
    dataSource: any
    start:Date|undefined
    end:Date|undefined
    selectedAssessmentType='All'
    assessmentTypes=[ "Follow Up Assessment 1", " Follow Up Assessement 2", "Follow Up Assessment 3", "Follow Up Assessment 4", "Follow Up Assessment 5", "Follow Up Assessment 6","Follow Up Assessment 7","Follow Up Assessment 8","Follow Up Assessment 9","Follow Up Assessment 10"];
mData:any[]=[]
  isLoading = false;  // New loading flag
    displayedColumns: string[] = ['sr.no','children', 'centre', 'sessionType', 'date', 'action'];
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    centres$: Observable<CentreOption[]>
    selectedCentre!: CentreOption ;

    constructor(private mFirestore: AngularFirestore,
                private readonly mCentreService: CentreService,
                private readonly mEducationService: EducationService,
                private readonly mSnackbar: MatSnackBar,
                private readonly mLogService: LogService,
                private readonly financialYearService: FinancialYearService,
                private matDialog: MatDialog) {
        this.centres$ = this.mCentreService.getAllCentresOptions().pipe(
            map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        )
    }

    ngOnInit(): void {
        // Pre-fill the date range with the current financial year (search still requires an explicit click)
        const fy = this.financialYearService.getCurrentFinancialYear();
        this.start = fy.startDate;
        this.end = fy.endDate;

        this.mFirestore.collection(this.env.educationFollowUp,ref => ref.orderBy('date','desc')).valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res => {
            this.dataSource = new MatTableDataSource<any>(res)
            this.dataSource.paginator = this.paginator
            this.dataSource.sort = this.sort
            console.log(this.dataSource)
            this.isLoading =false
        })
    }


    viewEdit(element: any) {
        this.matDialog.open(FollowUpQuestionComponent, {
                data: element,
                autoFocus: false,
                width: '800%',
                height: '90%'
            }
        )
    }

  deleteChild(element: any) {
    if (!confirm("Are you sure you want to delete this record?")) {
      return;
    }

    this.mEducationService.deleteFollowUpAssessment(element)
      .then(() => {
        console.log("Deleted successfully");
        this.mSnackbar.open('Record deleted successfully', 'OK', { duration: 3000 });
      })
      .catch((error: any) => {
        console.error("Error deleting record:", error);
        this.mSnackbar.open('Failed to delete record. Please try again.', 'OK', { duration: 4000 });
      });
  }


  OpenDialog() {
        this.matDialog.open(FollowUpQuestionComponent, {
            autoFocus: false,
            width: '800%',
            height: '90%'
        })
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    viewDialog(element: any) {
        this.matDialog.open(ViewFollowUpEducationComponent, {
            autoFocus: false,
            data: element,
            width: '800%',
            height: '90%'
        })
    }

  filterData() {
    let filtered = this.mData;

    if (this.selectedAssessmentType && this.selectedAssessmentType !== 'All') {
      filtered = filtered.filter(x => x.sessionType === this.selectedAssessmentType);
    }

    this.dataSource.data = filtered;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  search() {
    console.log('centreCode', this.selectedCentre?.centreCode);
    console.log('Start', this.start);
    console.log('End', this.end);

    this.isLoading = true; // Start loading
    this.mData = [];

    let query;

    if (!this.selectedCentre || !this.selectedCentre?.centreCode || this.selectedCentre?.centreCode === 'All') {
      // If "All Centres" is selected, filter by date range
      query = this.mFirestore.collection(this.env.educationFollowUp, ref => {
        let baseQuery = ref.orderBy('date', 'desc');

        if (this.start && this.end) {
          baseQuery = baseQuery.where('date', '>=', this.start).where('date', '<=', this.end);
        }

        return baseQuery;
      });
      this.isLoading = false;
    } else {
      // If a specific center is selected, filter by center and date
      query = this.mFirestore.collection(this.env.educationFollowUp, ref => {
        let baseQuery = ref.orderBy('date', 'desc')
          .where('centreCode', '==', this.selectedCentre?.centreCode);

        if (this.start && this.end) {
          baseQuery = baseQuery.where('date', '>=', this.start).where('date', '<=', this.end);
        }

        return baseQuery;
      });
      this.isLoading = false;
    }

    query.valueChanges({ idField: 'id' }).pipe(
      finalize(() => { this.isLoading = false; }), // Ensure loader stops
      takeUntil(this._destroyed$)
    ).subscribe(res => {
      this.mData = res;
      this.dataSource = new MatTableDataSource<any>(this.mData);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.filterData();
      console.log(this.dataSource.data.length);
    });
  }

  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
    this.selectedCentre = undefined!;
    this.selectedAssessmentType = 'All';
    this.mData = [];
    this.dataSource = new MatTableDataSource<any>([]);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  downloadExcel() {
    const tableData = this.dataSource?.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource?.data;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Child Name</th>
        <th>Centre</th>
        <th>Assessment Type</th>
        <th>Date</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x.childName ?? '-'}</td>
        <td>${x.centreName ?? '-'}</td>
        <td>${x.sessionType ?? '-'}</td>
        <td>${
        x.date && x.date.toDate
          ? new Date(x.date.toDate()).toLocaleDateString('en-GB')
          : '-'
      }</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Education_Follow_Up_Assessment_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }


  private filterDate(mData: any[]) {
    this.mData = mData.filter(x =>
      x.date && x.date.toDate && x.date.toDate() >= this.start! && x.date.toDate() <= this.end!
    );

    if (this.selectedAssessmentType !== 'All') {
      this.mData = this.mData.filter(x => x.sessionType === this.selectedAssessmentType);
    }
  }




  protected readonly PermissionType = PermissionType;

  protected toggleHighlight(element: any) {
    this.mEducationService.toggleFollowUpHighlight(element)
      .then(() => {
        let activity = {
          date: new Date().getTime(),
          section: 'Follow Up Assessment',
          action: 'Toggle Highlight',
          description: `Follow Up Assessment ${element.isHighlight ? 'highlighted' : 'unhighlighted'} by user`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);
      })
      .catch(err => {
        console.error('Error toggling highlight:', err);
        element.isHighlight = !element.isHighlight; // revert on error
      });
    element.isHighlight = !element.isHighlight; // optimistic update
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
